import React from 'react';
import { interviewBlock } from '../state/derive';
import { fmtTime } from '../state/format';

const e = React.createElement;

/**
 * The half hour the day holds for the sitting placed on it.
 *
 * Not a card and not a question here: the day comes from the answer the
 * bride and the groom gave in the sittings, so this only shows where it
 * falls and moves with whatever it hangs on. It says whose sitting it is,
 * the pair's where they both chose this day and one of theirs where only
 * one did. Nothing on it is editable, which is why it reads as a band
 * rather than as a card with its controls taken away.
 */
const InterviewBlock = ({ entry }) => {
  const block = interviewBlock(entry);
  if (!block) return null;
  return e('div', { className: 'wd-ivblock' }, [
    e('span', { className: 'wd-ivmark', key: 'm', 'aria-hidden': 'true' }, '●'),
    e('span', { className: 'wd-ivname', key: 'n' },
      entry.interview_label || 'Bride and groom interview'),
    e('span', { className: 'wd-ivmins', key: 'd' }, `${block.minutes} min`),
    // The band stands from the moment the ceremony does, the way the couple
    // shot's does. Until the ceremony has a time there is none to show, so
    // it says so in the same words the cards use.
    block.start
      ? e('span', { className: 'wd-ivwhen', key: 'w' },
          `${fmtTime(block.start)} to ${fmtTime(block.end)}`)
      : e('span', { className: 'wd-ivwhy', key: 'w' }, 'Timings not set yet'),
    block.start
      ? e('span', { className: 'wd-ivwhy', key: 'y' }, 'held for you')
      : null,
  ]);
};

export default InterviewBlock;
